package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.series_tab.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.loyalty_card_detail.LoyaltyCardDetail
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components.tabs.series_tab.getCustomerCardSeriesBorderColor
import org.jetbrains.compose.web.attributes.InputType

@Composable
fun LoadingLabeling(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    windowSizeMode: WindowSizeModeEnum,
    loadMapLoading: Boolean,
    loadLabelLoading: Boolean,
    updateLoadingWorkCards: (Int, Int, Int, String) -> Unit,
    updateLabelingWorkCards: (Int, Int, String) -> Unit,
)
{
    Column(
        modifier = Modifier
            .margin(top = Dimen.mediumPadding)
    )
    {
        MediumContentTitle(
            title = Strings.current().loadingLabeling,
        )
        if (windowSizeMode== WindowSizeModeEnum.Desktop){
            Row(
                modifier = Modifier.margin(top = Dimen.normalPadding)
            )
            {
                LeftContent(
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    loadMapLoading=loadMapLoading,
                    updateRangeLoyaltyCard={from:Int,to:Int,balance:Int,desc:String->
                        updateLoadingWorkCards(
                            from,to,balance,desc
                        )
                    },
                )


                RightContent(
                    loadLabelLoading=loadLabelLoading,
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    updateLabelingWorkCards={ from:Int,to:Int,name:String->
                        updateLabelingWorkCards(from,to,name)
                    }
                )
            }
        }else{
            Column (
                modifier = Modifier.margin(top = Dimen.normalPadding)
            )
            {
                LeftContent(
                    loadMapLoading = loadMapLoading,
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    updateRangeLoyaltyCard={from:Int,to:Int,balance:Int,desc:String->
                        updateLoadingWorkCards(
                            from,to,balance,desc
                        )
                    },
                )


                RightContent(
                    selectedLoyaltyCard=selectedLoyaltyCard,
                    loadLabelLoading = loadLabelLoading,
                    updateLabelingWorkCards={ from:Int,to:Int,name:String->
                        updateLabelingWorkCards(from,to,name)
                    },
                )
            }
        }







    }
}

@Composable
private fun RightContent(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    loadLabelLoading: Boolean,
    updateLabelingWorkCards: (Int, Int, String) -> Unit,
) {
    val from= remember { mutableStateOf("") }
    val until= remember { mutableStateOf("") }
    val name= remember { mutableStateOf("") }

    LaunchedEffect(selectedLoyaltyCard){
        name.value=""
        until.value=""
        from.value=""
    }
    Column(
        modifier = Modifier
            .margin(left = Dimen.largePadding)
    )
    {
        SpanText(
            text = Strings.current().labelingWorkCards,
            modifier = Modifier
                .fontSize(FontSizes.mediumFontSize)
                .color(Theme.TextPrimary.rgb)
                .fontFamily(FontFamily.Jakarta)

        )

        Row(
            verticalAlignment = Alignment.CenterVertically
        )
        {
            CustomEditText(
                modifier = Modifier,
                label = Strings.current().from,
                value = from.value,
                inputType = InputType.Number,
                marginRight = Dimen.largePadding,
                isDecimal = true,
                defaultBorderColor = getCustomerCardSeriesBorderColor(
                    from=from.value,
                    until=until.value
                ),
                width = Dimen.semiNormalEditTextWidth,
                marginBottom = Dimen.highLargePadding,
                isRequired = false,
                hint = "",
                onFocusIn = {

                },
                onFocusOut = {},
                onInputChange = {it, validation ->
                    from.value=it
                },
            )


            CustomEditText(
                modifier = Modifier,
                label = Strings.current().until,
                value = until.value,
                inputType = InputType.Number,
                width = Dimen.semiNormalEditTextWidth,
                marginRight = Dimen.largePadding,
                isDecimal = true,
                defaultBorderColor = getCustomerCardSeriesBorderColor(
                    from=from.value,
                    until=until.value
                ),
                isRequired = false,
                hint = "",
                marginBottom = Dimen.highLargePadding,
                onFocusIn = {

                },
                onFocusOut = {},
                onInputChange = {it, validation ->
                    until.value=it
                },
            )


        }




        CustomEditText(
            modifier = Modifier,
            label = Strings.current().cardHolder,
            value = name.value,
            marginBottom = Dimen.largePadding,
            isRequired = false,
            hint = "",
            onFocusIn = {

            },
            onFocusOut = {},
            onInputChange = {it, validation ->
                name.value=it
            },
        )


        CustomButton(
            modifier = Modifier
                .margin(topBottom =Dimen.mediumPadding ),
            loading = loadLabelLoading,
            isClickable = (
                    name.value.isNotEmpty()
                    && from.value.isNotEmpty()
                    && until.value.isNotEmpty()
                    && from.value.toInt()<=until.value.toInt()
                ),
            title = Strings.current().loadLabels,
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick = {
                updateLabelingWorkCards(
                    from.value.toInt(),
                    until.value.toInt(),
                    name.value
                )
            }

        )
    }
}

@Composable
private fun LeftContent(
    selectedLoyaltyCard: LoyaltyCardDetail?,
    updateRangeLoyaltyCard: (Int, Int, Int, String) -> Unit,
    loadMapLoading: Boolean,
) {
    val from= remember { mutableStateOf("") }
    val until= remember { mutableStateOf("") }
    val balance= remember { mutableStateOf("") }
    val desc= remember { mutableStateOf("") }



    LaunchedEffect(selectedLoyaltyCard){
        desc.value= LanguageManager.getCurrentStrings().loadingWorkCards
        from.value=""
        until.value=""
        balance.value=""

    }

    Column()
    {
        SpanText(
            text = Strings.current().loadingWorkCards,
            modifier = Modifier
                .fontSize(FontSizes.mediumFontSize)
                .color(Theme.TextPrimary.rgb)
                .fontFamily(FontFamily.Jakarta)

        )
        Row(
            verticalAlignment = Alignment.CenterVertically
        )
        {
            CustomEditText(
                modifier = Modifier,
                label = Strings.current().from,
                value = from.value,
                inputType = InputType.Number,
                marginRight = Dimen.largePadding,
                isDecimal = true,
                defaultBorderColor = getCustomerCardSeriesBorderColor(
                    from=from.value,
                    until=until.value
                ),
                width = Dimen.semiNormalEditTextWidth,
                marginBottom = Dimen.highLargePadding,
                isRequired = false,
                hint = "",
                onFocusIn = {  },
                onFocusOut = {},
                onInputChange = {it, validation ->
                    from.value=it
                },
            )


            CustomEditText(
                modifier = Modifier,
                label = Strings.current().until,
                inputType = InputType.Number,
                value = until.value,
                width = Dimen.semiNormalEditTextWidth,
                isDecimal = true,
                defaultBorderColor = getCustomerCardSeriesBorderColor(
                    from=from.value,
                    until=until.value
                ),
                marginRight = Dimen.largePadding,
                isRequired = false,
                hint = "",
                marginBottom = Dimen.highLargePadding,
                onFocusIn = {

                },
                onFocusOut = {},
                onInputChange = {it, validation ->
                    until.value=it
                },
            )


        }

        CustomEditText(
            modifier = Modifier,
            label = Strings.current().balance,
            value = balance.value,
            marginRight = Dimen.largePadding,
            isDecimal = true,
            inputType = InputType.Number,
            width = Dimen.semiNormalEditTextWidth,
            marginBottom = Dimen.highLargePadding,
            isRequired = false,
            hint = "",
            onFocusIn = {

            },
            onFocusOut = {},
            onInputChange = {it, validation ->
                balance.value=it
            },
        )


        CustomEditText(
            modifier = Modifier,
            label = Strings.current().name,
            value = desc.value,
            marginBottom = Dimen.mediumPadding,
            isRequired = false,
            hint = "",
            onFocusIn = {

            },
            onFocusOut = {},
            onInputChange = {it, validation ->
                desc.value=it
            },
        )


        CustomButton(
            modifier = Modifier
                .margin(topBottom = Dimen.mediumPadding),
            loading = loadMapLoading,
            isClickable = (
                    from.value.isNotEmpty()
                    && until.value.isNotEmpty()
                    && balance.value.isNotEmpty()
                    && from.value.toInt()<=until.value.toInt()
            ),
            title = Strings.current().loadMaps,
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick = {
                updateRangeLoyaltyCard(
                    from.value.toInt()
                    ,until.value.toInt()
                    ,balance.value.toInt()
                    ,desc.value
                )
            }

        )


    }
}